import Vue from "vue";
import { Route } from "vue-router";

export const drawerState = Vue.observable({
  isCollapsed: false,
  isVisible: true,
  isRouteWithDisplayState: (() => false) as (route: Route) => boolean,
  triggerStyle: {
    beforeBackgroundColor: "white",
    beforeSize: "22px",
    iconColor: "primary",
    iconSize: "9",
    right: "-13px",
    size: "26px",
  },
});
